<template>
  <div
    :class="$style.root"
    :data-has-pagination="childData?.meta?.pagination?.page < childData?.meta?.pagination?.pageCount ? '' : null"
  >
    <LayoutPageHeaderComponent :data="localizedData" />

    <ul :class="$style.list">
      <li
        v-for="(entry, index) in childData?.data"
        :class="$style.item"
      >
        <PagesEditionsEntryComponent
          :entry="entry"
          :data-last-child="index === childData?.data?.length - 1 ? '' : null"
        />
      </li>
    </ul>

    <LayoutPaginationComponent
      :pagination="childData?.meta?.pagination"
      :paginateChildData="paginateChildData"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  pageData: Object,
  childData: {
    type: Object,
    required: false,
  },
  paginateChildData: {
    type: Function,
    required: false,
  }
})

const localizedData = computed(() => {
  return i18nGetLocalizedData(baseStrapiGetAttributes(props?.pageData?.data))
})

</script>

<style module>
.root {
}

.list {
  composes: reset-list from global;
}
</style>
